import { createGtm } from '@gtm-support/vue-gtm';

const path = window.location.pathname;
const routeHit = /\/launchpad|\/launchdetail|\/vote-/.test(path);
const envHit = process.env.NODE_ENV !== 'development';

export const gtm = createGtm({
    id: 'GTM-PMHBL76',
    defer: true,
    compatibility: true,
    enabled: routeHit && envHit,
    debug: false,
    loadScript: true,
    trackOnNextTick: false,
});
